import { IUserInfo } from './types';
import { get } from '@web3/base-utils';

export const getUserInfo = () => {
  return get<IUserInfo>(`/v2/private/user/profile`, {});
};
